<template>
  <el-form-item :label="label" label-width="80px">
    <el-input
      v-model="abroadTime"
      suffix-icon="el-icon-date"
      placeholder="选择月份"
      @focus="abroadTimeDialog2 = true"
    ></el-input>
    <el-dialog :title="'选择' + label" :visible.sync="abroadTimeDialog2" :modal="false">
      <el-form>
        <el-row :span="20">
          <el-col :span="10">
            <el-form-item label="年份">
              <el-select v-model="query.year" placeholder="请选择年份" filterable style="width:100%;">
                <el-option v-for="item in yearList" :label="item + '年'" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="月份">
              <el-select v-model="query.month" placeholder="请选月份" filterable style="width:100%;">
                <el-option v-for="item in [1, 4, 7, 10]" :label="item + '月'" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="yesClick()">确 定</el-button>
        <el-button
          type="info"
          @click="abroadTimeDialog2 = false; abroadTime = ''; $emit('selabroad', abroadTime);"
        >清 空</el-button>
      </span>
    </el-dialog>
  </el-form-item>
</template>

<script>
import dateHelper from "@/plugins/dateHelper.js";

export default {
  props: {
    label: { type: String, default: "留学时间" },
    time: String,
    minYear: { type: Number, default: null }
  },
  data() {
    return {
      abroadTimeDialog2: false,
      abroadTime: "",
      query: {},
      yearList: []
    };
  },
  methods: {
    yesClick() {
      this.abroadTimeDialog2 = false;
      var query = this.query;
      if (query.year && query.month) {
        this.abroadTime = query.year + "-" + query.month;
        this.$emit("selabroad", this.abroadTime);
      }
    },
    setAbroadTime(time) {
      this.abroadTime = time || "";
    }
  },
  mounted() {
    var years = dateHelper.getYearList();
    if (this.minYear) {
      years = years.filter(y => Number(y) >= Number(this.minYear));
    }
    this.yearList = years;
  }
};
</script>
